import type { GameLaunchPayload } from '@/logic/game-info/game-info';
import { getGameSelectedProps } from '@/tracking/amplitude/events/general/game-selected';
import { getPageName } from '@/tracking/amplitude/utils';

export const MOBILE_BOTTOM_NAV_MODULE = 'mobile_bottom_nav';

export const buildBottomNavGameSelectedProps = (gameLaunchData?: GameLaunchPayload) => {
    const gameProvider = gameLaunchData?.gameProvider ?? gameLaunchData?.launcherUrlProps?.providerName;

    return getGameSelectedProps({
        module: MOBILE_BOTTOM_NAV_MODULE,
        gameName: gameLaunchData?.gameName ?? '',
        gameUid: gameLaunchData?.gameUid ?? '',
        ...(gameProvider !== undefined && { gameProvider }),
        pageName: getPageName() || 'home'
    });
};
